import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStore } from '../lib/userStore';
import { useLeagueStore } from '../lib/leagueStore';
import {
  isTrackablePath,
  normalizePagePath,
  recordPageView,
  shouldRecordPageView,
} from '../lib/pageViewTracking';

/**
 * Enregistre les pages visitées (hors auth/dev). Ne dépend que du pathname :
 * les changements de query/hash sont ignorés. Attend user_id + league_id.
 */
export function PageViewTracker() {
  const { pathname } = useLocation();
  const username = useUserStore((s) => s.username);
  const userId = useUserStore((s) => s.user_id);
  const isImpersonating = useUserStore((s) => s.is_impersonating);
  const leagueId = useLeagueStore((s) => s.selectedLeague?.id ?? null);

  useEffect(() => {
    if (import.meta.env.DEV) return;
    if (!username || !userId || !leagueId || isImpersonating) return;
    if (!isTrackablePath(pathname)) return;
    const path = normalizePagePath(pathname);
    if (!shouldRecordPageView(`${userId}|${leagueId}|${path}`)) return;
    void recordPageView(userId, leagueId, path);
  }, [pathname, username, userId, leagueId, isImpersonating]);

  return null;
}
